import React from 'react';
import Flex from '@components/layout/flex';
import styled from 'styled-components';
import MotionOpacity from '@components/motion/motion-opacity';
import FormContainer from '@components/layout/form-container';
import Typography from '@components/basics/typography';
import CircleCheckFilledIcon from '@components/basics/icons/circle-check-filled';
import { Translate } from 'react-localize-redux';
import moment from 'moment';
import { CallHistoryMethodAction } from 'connected-react-router';
export default function RemoveManagerConfirmation({
  username,
  redirectToCatalog
}: {
    username?: string,
    redirectToCatalog: () => CallHistoryMethodAction | void;
}) {
  const currentDate = moment(Date.now()).format('DD MMM YYYY');
  React.useEffect(() => {
      setTimeout(function () {
        redirectToCatalog();
      }, 10000);
  }, [redirectToCatalog]);
  return (
    <MotionOpacity>
      <FormContainer>
        <Center>
          <EmptyDiv>
            <Content>
              <FlexContainer>
                <CircleCheckFilledIcon iconSize={28} />
                <FlexColunnContainer>
                  <Typography weight="400" customSize={'12px'}>
                    {currentDate}
                  </Typography>
                </FlexColunnContainer>
              </FlexContainer>
              <Typography
                className="mb-20 mt-20 text-align-start w-100"
                align="center"
                type="subheader"
                weight="400"
              >
                {`You've successfully removed ${username} from your team.`}
              </Typography>
              <Typography
                weight="400"
                type="title"
                opacity=".5"
                className="mt-10 text-align-start w-100"
              >
                All users associated with the release will be notified.
              </Typography>
            </Content>
            <ContinueToCatalog>
              <Flex
                justifyContent="space-between"
                alignItems="flex-start"
                margin="10px 0 0 0"
                className="w-100"
              >
                <FlexContainer>
                    <Typography
                      type={'link'}
                      onClick={redirectToCatalog}
                      weight="700"
                      customSize={'12px'}
                    >
                      <Translate id="SUCCESS.REDIRECT" />
                    </Typography>
                    <Typography
                      type={'link'}
                      onClick={redirectToCatalog}
                      uppercase
                      weight="400"
                      customSize={'12px'}
                      className="text-decoration-underline"
                    >
                      <Translate id="RELEASE.PUBLISHED.CONTINUE" />
                    </Typography>
                </FlexContainer>
              </Flex>
            </ContinueToCatalog>
          </EmptyDiv>
        </Center>
      </FormContainer>
    </MotionOpacity>
  );
}
const EmptyDiv = styled.div``;
const Content = styled(Flex).attrs(() => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}))`
  background-color: ${({ theme }) => theme.colors.background};
  min-width: 395px;
  padding: 24px;
  .expiry {
    margin-top: 20px;
  }
  margin-top: 40px;
  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    margin-top: 60px;
  }
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 200px);
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const FlexColunnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: end;
  width: 100%;
`;
const ContinueToCatalog = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  min-width: 395px;
  font-size: 10px;
  margin-top: 30px;
  color: #32343c;
`;
